import { z } from "zod";
import { ENERGY_LEVELS, TEMPERAMENTS } from "./common";

export const ownerProfileSchema = z.object({
  firstName: z
    .string()
    .nonempty("First name is required")
    .min(2, "First name must be at least 2 characters long"),
  lastName: z
    .string()
    .nonempty("Last name is required")
    .min(2, "Last name must be at least 2 characters long"),
  phone: z
    .string()
    .nonempty("Phone number is required")
    .regex(/^(?:\+|0)\d{1,4}[\d-]{1,20}$/, "Invalid phone number format"),
  locality: z
    .string()
    .nonempty("City is required")
    .min(2, "City must be at least 2 characters long"),
  news: z.boolean().default(false),
});

export const dogProfileSchema = z.object({
  name: z.string().nonempty("Dog name is required"),
  breed: z.string().nonempty("Dog breed is required"),
  birthDate: z.date(),
  energyLevel: z.enum(ENERGY_LEVELS),
  temperament: z.enum(TEMPERAMENTS),
  trainingNeeds: z.string().optional(),
  healthConcerns: z.string().optional(),
  sterilised: z.boolean().optional(),
  medication: z.string().optional(),
});
